<template>
  <!-- メルマガ登録フォーム -->
  <div class="top-contact-content-mail-box" v-if="!hideMagazineForm">

    <center>
    <div class="top-contact-content-mail-box-title">
        新着車両や在庫情報などを<br class="mobi">お知らせします
    </div>
    </center>

    <div class="top-contact-content-mail-box-text sans">
      新しく入荷したクルマや、<br class="mobi">おすすめのクルマ情報など、<br>お客様のお役にたつ情報をお届けします。<br class="mobi">是非ご登録ください。
    </div>

    <div class="top-contact-content-mail-box-search of">
    <input type="text" placeholder="メールアドレス" v-model="mailForm.mailAddress">
    <button @click="submitMail()" v-if="!mailForm.sending">
      {{ mailForm.suceeded ? '登録完了' : '送信する'  }}
    </button>
    <vue-element-loading
      :active="mailForm.sending"
      spinner="spinner"
      color="#004da0"
    />
    <div class="mail-box-error">{{ mailForm.error }}</div>
    </div>

  </div>
  <!-- /メルマガ登録フォーム -->
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import VueElementLoading from "vue-element-loading";

import { getCsrfToken } from "@/api/common";
import { send } from "@/api/mailMagazine";

/**
 * Page コンポーネントから使用されます。
 */
export default defineComponent({
  components: {
    VueElementLoading,
  },
  setup () {
    const mailForm = ref({
      sending: false,
      mailAddress: '',
      prefecture: '',
      error: '',
      suceeded: false,
    });

    watch(() => mailForm.value.mailAddress, () => {
      mailForm.value.error = '';
      mailForm.value.suceeded = false;
    });

    const submitMail = async () => {
      if (mailForm.value.sending ) return;
      mailForm.value.error = '';
      mailForm.value.sending = true;
      try {
        await getCsrfToken();
        await send({ json: mailForm.value });
        mailForm.value.suceeded = true;
      } catch(e) {
        mailForm.value.error = "登録できませんでした。";
      } finally {
        mailForm.value.sending = false;
      }
    };

    return {
      mailForm,
      submitMail,
    };
  },
});
</script>

<style lang="scss" scoped>
.mail-box-error {
  box-sizing: border-box;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.05vw;
  margin-top: 37px;
  padding-top: 24px;
  text-align: center;
}
</style>